<template>
  <el-container>
    <el-header class="header" height="48px">
      <el-col :span="8" class="left-header">
        <span class="title">易维迅轨道交通集成管理平台设备运维服务平台软件V1.0<span>MC²</span></span>

      </el-col>
      <el-col :span="16" class="right-header">
        <el-popover trigger="hover">
          <div style="padding:12px;width:250px;">
            <el-row>
              <el-col style="text-align:center;font-size:15px;">
                <span>{{ companyName }}</span>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col style="text-align: center;line-height: 80px;height:80px">
                <el-avatar :src="wechatUrl" :size="80">{{ userName }}</el-avatar>
              </el-col>
            </el-row>
            <el-row>
              <el-col style="text-align: center;line-height: 60px;height:60px">
                <span style="font-size:24px;font-weight: bold;">{{ userName }}</span>
                <el-tag size="mini" type="warning" v-if="orgName == null || orgName == ''">无部门信息</el-tag>
                <el-tag size="mini" style="margin-left:8px" v-else>{{ orgName }}</el-tag>
              </el-col>
            </el-row>

            <el-row>
              <el-col style="height:50px">
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-button type="primary" style="width:100%" size="mini" @click="resetPassword_init"><i
                    class="el-icon-lock el-icon--left"></i>修改密码</el-button>
              </el-col>
              <el-col :span="12">
                <el-button type="danger" style="width:100%" size="mini" @click="exit">注销用户<i
                    class="el-icon-switch-button el-icon--right"></i></el-button>
              </el-col>
            </el-row>
          </div>
          <span slot="reference" style="font-size: 15px;cursor: pointer;">
            <i class="el-icon-user-solid el-icon--left"></i>{{ userName }}
          </span>
        </el-popover>
      </el-col>
    </el-header>
    <el-main class="content">
      <el-container @click.native="hideRefresh">
        <el-button type="success" icon="el-icon-font el-icon-tubiao01" size="mini" class="refresh" :style="{
          position: 'absolute',
          'z-index': '9999999',
          left: refreshL,
          top: refreshT,
        }" v-show="refreshShow" @click="refresh">刷新</el-button>
        <el-aside style="transition: 0.3s;overflow-x: hidden;" :width="asidewidth">
          <es-left :menus="menus" @change-width="chagewidth" @add-tab="add_tab" :defaultmenu="menuname"></es-left>
        </el-aside>
        <el-main style="overflow: hidden;padding:0px">
          <el-tabs type="border-card" class="tabs" v-model="selected" @tab-click="click_menu" @tab-remove="remove_tab">
            <el-tab-pane name="outline" class="pane">
              <span slot="label" @contextmenu="refreshButtom($event, 0)"><i
                  class="el-icon-font el-icon-dashboard_vs el-icon--left"></i>总览</span>
              <eshome ref="comp0" :funcs="funcs == null ? [] : funcs" v-if="outlineUpdate" @add-tab="add_tab"></eshome>
            </el-tab-pane>
            <el-tab-pane v-for="item of tabpanes" class="pane" :closable="true" :name="item.id + ''" :key="item.id">
              <span slot="label" @contextmenu="refreshButtom($event, item.id)"><i
                  :class="['el-icon-font', item.icon, 'el-icon--left']"></i>{{ item.label }}</span>
              <component :ref="'comp' + item.id" :is="item.url.substring(item.url.lastIndexOf('/') + 1)"
                :paramId="item.paramId" :funcs="funcs == null ? [] : funcs" @add-tab="add_tab"
                v-if="item.update == null || item.update == true">
              </component>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-main>
    <!--修改密码-->
    <el-dialog :visible.sync="resetPasswordVisible" @closed="() => this.$refs['passwordForm'].clearValidate()"
      width="500px">
      <span slot="title">
        <i class="el-icon-lock el-icon--left"></i>修改密码
      </span>
      <el-tag type="warning" style="margin-bottom: 12px;">新密码中必须包含大小写字母、数字、特殊字符。至少8个字符、最多20个字符。</el-tag>
      <el-form :model="userInfo" :rules="rules" size="mini" label-position="right" label-width="150px" ref="passwordForm">
        <el-form-item prop="oldPassword" label="老密码">
          <el-input v-model="userInfo.oldPassword" type="password" placeholder="请输入老密码" style="width:200px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" label="新密码">
          <el-input v-model="userInfo.password" type="password" placeholder="请输入新密码" style="width:200px" clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="确认密码">
          <el-input v-model="userInfo.confirmPassword" type="password" placeholder="请确认新密码" style="width:200px" clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="resetPasswordVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitPassword()" :loading="isSaving">保 存</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name: 'esmain',
  data () {
    //自定义密码验证
    let validatePassword = (rule, value, callback) => {
      var regExp = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}')
      if (!regExp.test(value)) {
        callback(new Error('密码复杂度不够，请重新输入'));
      } else {
        callback();
      }
    };
    //自定义确认密码
    let validateConfirmPassword = (rule, value, callback) => {
      if (this.userInfo.password != value) {
        callback(new Error('确认密码跟新密码不一致'));
      } else {
        callback();
      }
    };
    return {
      userId: this.$store.getUser().id,
      userName: this.$store.getUser().userName,
      orgName: this.$store.getUser().orgName,
      companyName: this.$store.getUser().companyName,
      wechatUrl: this.$store.getUser().wechatUrl,
      funcs: this.$store.getUser().funcs,
      userInfo: {},//用户信息
      rules: {//验证条件
        oldPassword: [
          { required: true, message: '请输入老密码', trigger: 'blur' },
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ],

      },
      resetPasswordVisible: false,//设置密码框显示
      isSaving: false,

      //设置菜单等数据
      asidewidth: '42px',
      selected: 'outline',
      tabpanes: [],
      menuname: '',
      refreshShow: false,
      refreshL: '200px',
      refreshT: '200px',
      refreshId: 0,
      outlineUpdate: true
    }
  },
  methods: {
    //初始化修改密码
    resetPassword_init () {
      this.resetPasswordVisible = true
      this.userInfo = { id: this.userId }
    },
    //保存密码信息
    submitPassword () {
      this.$refs["passwordForm"].validate(valid => {
        if (valid) {
          this.isSaving = true
          this.$ajax.post("/base/account/edit_password", this.userInfo).then(msg => {
            this.isSaving = false
            this.resetPasswordVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.isSaving = false
          })
        }
      })
    },
    exit () {
      this.$confirm('确定注销当前用户吗？', '确认框', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax.post('/base/logout').then(msg => {
          this.$router.replace('/')
          this.$message.success(msg)
        }).catch(err => {
          this.$message.error(err)
        })
      })
    },

    //设置菜单等数据
    chagewidth (w) {
      this.asidewidth = w
    },
    add_tab (tabinfo) {
      let flag = false
      if (this.tabpanes != null) {
        for (let i = 0; i < this.tabpanes.length; i++) {
          if (this.tabpanes[i].id == tabinfo.id) {
            flag = true
            break
          }
        }
      }
      if (!flag) {
        //新打开一个tab
        this.tabpanes.push(tabinfo)
      } else {
        //如果是查看列表中的某个详情弹出框，将刷新页面
        if (tabinfo.paramId != null) {
          for (let i = 0; i < this.tabpanes.length; i++) {
            if (this.tabpanes[i].id == tabinfo.id) {
              this.$set(this.tabpanes[i], "update", false)
              this.$nextTick(() => {
                this.$set(this.tabpanes[i], "update", true)
                this.$set(this.tabpanes[i], "paramId", tabinfo.paramId)
              })
            }
          }
        }
      }

      this.selected = tabinfo.id + ''
    },
    click_menu (tab) {
      this.menuname = tab.name
    },
    remove_tab (name) {
      let delindex = null
      for (let i = 0; i < this.tabpanes.length; i++) {
        if (this.tabpanes[i].id + '' == name) {
          delindex = i
          if (name == this.selected) {
            //当前打开的tab是关闭的tab，才会默认打开前一个tab
            if (i == 0) {
              this.selected = 'outline'
            } else {
              this.selected = this.tabpanes[i - 1].id + ''
              this.menuname = this.selected
            }
          }
          break
        }
      }
      this.tabpanes.splice(delindex, 1)
    },
    refreshButtom (e, id) {
      e.preventDefault()
      this.refreshId = id
      this.refreshShow = true
      this.refreshL = e.pageX + 'px'
      this.refreshT = e.pageY + 'px'
    },
    refresh () {
      if (this.refreshId == 0) {
        this.outlineUpdate = false
        this.$nextTick(() => {
          this.outlineUpdate = true
        })
      } else {
        for (let i = 0; i < this.tabpanes.length; i++) {
          if (this.tabpanes[i].id + '' == this.refreshId) {
            this.$set(this.tabpanes[i], "update", false)
            this.$nextTick(() => {
              this.$set(this.tabpanes[i], "update", true)
            })
          }
        }
      }
    },
    hideRefresh () {
      this.refreshShow = false
    },
  },
  computed: {
    menus () {
      return JSON.parse(this.$store.getUser().menus)
    }
  },
  components: {
    esLeft: () => import('./esleft'),
    eshome: () => import('./eshome'),
    org: () => import('./system/org'),
    role: () => import('./system/role'),
    sys: () => import('./system/sys'),
    account: () => import('./system/account'),
    //人员管理
    usermanage: () => import('./system/usermanage'),
    certimanage: () => import('./system/certimanage'),
    cultimanage: () => import('./system/cultimanage'),
    knowledge: () => import('./system/knowledge'),
    notice: () => import('./system/notice'),
    certificate: () => import('./system/certificate'),
    cultivate: () => import('./system/cultivate'),
    //系统管理   
    faucusfield: () => import('./system/faucusfield'),
    dict: () => import('./system/dict'),
    robduration: () => import('./system/robduration'),

    //设备管理
    assetarea: () => import('./asset/area'),
    assetareatype: () => import('./asset/areatype'),
    factory: () => import('./asset/factory'),
    assettype: () => import('./asset/type'),
    model: () => import('./asset/model'),
    asset: () => import('./asset/asset'),
    extenddef: () => import('./asset/extenddef'),
    module: () => import('./asset/module'),//设备模块

    //故障管理
    faultlevel: () => import('./fault/faultlevel'),//故障等级
    faultappe: () => import('./fault/faultappe'),//故障现象及解决方法
    fauhangreason: () => import('./fault/fauhangreason'),//故障挂起原因
    faultreport: () => import('./fault/faultreport'),//故障上报
    faultdist: () => import('./fault/faultdist'),//故障干预
    faultquery: () => import('./fault/faultquery'),//故障查询

    //巡检管理
    item: () => import('./ins/item'),//巡检项设置
    instemplate: () => import('./ins/instemplate'),//巡检模版设置
    insline: () => import('./ins/insline'),//线路管理
    inslinetime: () => import('./ins/inslinetime'),//线路管理
    insmanage: () => import('./ins/insmanage'),//线路管理
    insquery: () => import('./ins/insquery'),//线路查询
    insassettime: () => import('./ins/insassettime'),//设备巡检规则设置
    insassetquery: () => import('./ins/insassetquery'),//设备巡检信息查看
    
    //任务管理
    task: () => import('./task/task'),//任务管理
    taskquery: () => import('./task/taskquery'),//任务查看
    tasktype: () => import('./task/tasktype'), //任务类型

    //排班管理
    rosteringtype: () => import('./rostering/rosteringtype'),//排班类别
    rosteringrule: () => import('./rostering/rosteringrule'),//排班规则
    rosteringplan: () => import('./rostering/rosteringplan'),//排班计划
    rosteringnowduty: () => import('./rostering/rosteringnowduty'),//当前在班人员
    rosteringnowdutydetails: () => import('./rostering/rosteringnowdutydetails'),//当前在班人员

    //保养管理
    maintain: () => import('./maintain/maintain'),//保养管理
    maintainquery: () => import('./maintain/maintainquery'),//保养查看
    //数据分析
    userstatistic: () => import('./statistic/userstatistic'),//人员分析
    assetstatistic: () => import('./statistic/assetstatistic'),//设备分析
    faultstatistic: () => import('./statistic/faultstatistic'),//故障分析
    matstatistic: () => import('./statistic/matstatistic'),//材料分析
    insstatistic: () => import('./statistic/insstatistic'),//巡检分析
    maintainstatistic: () => import('./statistic/maintainstatistic'),//保养分析
    taskstatistic: () => import('./statistic/taskstatistic'),//任务分析
    report: () => import('./statistic/report'),//任务分析
    faulthour: () => import('./statistic/faulthour'),//工时管理
    personpoint: () => import('./statistic/personpoint'),//打卡记录
    //word报表
    templateManage: () => import('./reportword/templateManage'),//报表模板管理
    createReport: () => import('./reportword/createReport'),//报表生成管理
  },
}
</script>

<style scoped>
.header {
  padding: 0;
  background-color: #409eff;
  color: white;
}

.left-header {
  height: 48px;
  line-height: 48px;
  padding-left: 12px;
}

.left-header .title {
  font-size: 20px;
  font-weight: bolder;
  letter-spacing: 2px;
}

.left-header .title span {
  margin-left: 2px;
  font-size: 12px;
  letter-spacing: 2px;
  position: absolute;
  top: -2px;
}

.right-header {
  text-align: right;
  padding-right: 12px;
  height: 48px;
  line-height: 48px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  margin-left: 10px;
}

.content {
  padding: 0;
  overflow: hidden;
  height: calc(100vh - 48px);
}

.tabs {
  height: 100%;
  background-color: transparent;
}

.pane {
  background-color: transparent;
}

.refresh {
  opacity: 0.9;
}
</style>
